<div class="project-totals-dialog" [class.pending-break-in-out]="hasPendingBreakInOut">
  @if (loading) {
  <div class="dialog-loading-overlay">
    <mat-progress-spinner mode="indeterminate" diameter="60"></mat-progress-spinner>
  </div>
  }
  <div mat-dialog-title>
    <div class="row align-items-center">
      <div class="col-sm-4">
        <mat-label class="dialog-title"> {{ 'DIALOGS.PROJECT_TOTALS.TITLE' | translate }}</mat-label>
        @if(description){
        <p>{{description}}</p>
        }
      </div>

      <div class="col-sm-4 text-center">
        <span class="last-month-outlook">
          {{ 'FORECAST.LAST_MONTH_FY_GRAND_TOTAL' | translate }}
          @if(showInK) {
          {{lastMonthGrandTotal ?? 0 | compactCurrency}} k$

          } @else {
          {{(lastMonthGrandTotal ?? 0) | number:'1.2-2'}}
          }
        </span>
      </div>

      <div class="col-sm-4 right-aligned">

        <mat-slide-toggle [(ngModel)]="showInK" color="primary" class="k-toggle">
          K$
        </mat-slide-toggle>

        <mat-icon (click)="onCancel()">close</mat-icon>
      </div>
    </div>
  </div>

  <mat-dialog-content>
    <div class="totals-columns-layout">
      <form class="report-form" [formGroup]="projectTotalsForm">
        <div class="table-wrapper-dialog">
          <div class="table-header-fixed">
            <table cellpadding="0" cellspacing="4" border="0">
              @if(carriedOverCostTotals) {
              <tr>
                <th colspan="6" class="section-title-row">
                  {{ 'DIALOGS.PROJECT_TOTALS.TITLE' | translate }}
                  <span class="section-title-divider">|</span>
                  <span [matTooltip]="'DIALOGS.PROJECT_TOTALS.AFE_NUMBER' | translate">{{ data.initiative?.afeNumber??0
                    }}</span>
                  <!-- <span class="section-title-divider">|</span> -->
                  <!-- <span [matTooltip]="'DIALOGS.PROJECT_TOTALS.AFE_AMOUNT' | translate">{{ (data.initiative?.afeAmount ?? 0) | number:'1.2-2' }}</span>
                <span class="section-title-divider">|</span>
                <span [matTooltip]="'DIALOGS.PROJECT_TOTALS.APPROVED_BUDGET' | translate">{{ (data.initiativeApprovedBudget ?? 0) | number:'1.2-2' }}</span> -->
                </th>
              </tr>
              }
              <tr>
                <th>{{ 'COMMON.LABELS.MONTH' | translate }}&nbsp;</th>
                <th>{{ 'COMMON.COST_TYPES.MATERIAL' | translate }}{{showInK ? ', K$' : ''}}</th>
                <th>{{ 'COMMON.COST_TYPES.SERVICE' | translate }}{{showInK ? ', K$' : ''}}</th>
                <th>{{ 'COMMON.COST_TYPES.OTHER' | translate }}{{showInK ? ', K$' : ''}}</th>
                <th>{{ 'COMMON.COST_TYPES.TOTAL' | translate }}{{showInK ? ', K$' : ''}}</th>
                @if(carriedOverCostTotals) {
                <th class="grand-total-col" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL' | translate">{{ 'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL' | translate }}{{showInK ? ', K$' : ''}}</th>
                }
              </tr>
            </table>
          </div>
          <div class="table-body-scroll">
            <table cellpadding="0" cellspacing="4" border="0">

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.JAN' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jan', 'material')"
                    [class.changed-field]="isFieldChanged('janMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="janMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('janMaterial')) {
                    <span class="old-value">{{ getOldValue('janMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jan', 'service')"
                    [class.changed-field]="isFieldChanged('janService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="janService"
                      maxlength="20000" />
                    @if (isFieldChanged('janService')) {
                    <span class="old-value">{{ getOldValue('janService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jan', 'other')"
                    [class.changed-field]="isFieldChanged('janOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="janOther"
                      maxlength="20000" />
                    @if (isFieldChanged('janOther')) {
                    <span class="old-value">{{ getOldValue('janOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="janTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('janTotal')?.value ?? 0) + getCarriedOverRowTotal('jan')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('janTotal')?.value ?? 0) + getCarriedOverRowTotal('jan')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.FEB' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('feb', 'material')"
                    [class.changed-field]="isFieldChanged('febMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="febMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('febMaterial')) {
                    <span class="old-value">{{ getOldValue('febMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('feb', 'service')"
                    [class.changed-field]="isFieldChanged('febService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="febService"
                      maxlength="20000" />
                    @if (isFieldChanged('febService')) {
                    <span class="old-value">{{ getOldValue('febService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('feb', 'other')"
                    [class.changed-field]="isFieldChanged('febOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="febOther"
                      maxlength="20000" />
                    @if (isFieldChanged('febOther')) {
                    <span class="old-value">{{ getOldValue('febOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="febTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('febTotal')?.value ?? 0) + getCarriedOverRowTotal('feb')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('febTotal')?.value ?? 0) + getCarriedOverRowTotal('feb')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.MAR' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('mar', 'material')"
                    [class.changed-field]="isFieldChanged('marMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="marMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('marMaterial')) {
                    <span class="old-value">{{ getOldValue('marMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('mar', 'service')"
                    [class.changed-field]="isFieldChanged('marService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="marService"
                      maxlength="20000" />
                    @if (isFieldChanged('marService')) {
                    <span class="old-value">{{ getOldValue('marService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('mar', 'other')"
                    [class.changed-field]="isFieldChanged('marOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="marOther"
                      maxlength="20000" />
                    @if (isFieldChanged('marOther')) {
                    <span class="old-value">{{ getOldValue('marOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="marTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('marTotal')?.value ?? 0) + getCarriedOverRowTotal('mar')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('marTotal')?.value ?? 0) + getCarriedOverRowTotal('mar')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.APR' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('apr', 'material')"
                    [class.changed-field]="isFieldChanged('aprMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="aprMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('aprMaterial')) {
                    <span class="old-value">{{ getOldValue('aprMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('apr', 'service')"
                    [class.changed-field]="isFieldChanged('aprService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="aprService"
                      maxlength="20000" />
                    @if (isFieldChanged('aprService')) {
                    <span class="old-value">{{ getOldValue('aprService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('apr', 'other')"
                    [class.changed-field]="isFieldChanged('aprOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="aprOther"
                      maxlength="20000" />
                    @if (isFieldChanged('aprOther')) {
                    <span class="old-value">{{ getOldValue('aprOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="aprTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('aprTotal')?.value ?? 0) + getCarriedOverRowTotal('apr')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('aprTotal')?.value ?? 0) + getCarriedOverRowTotal('apr')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.MAY' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('may', 'material')"
                    [class.changed-field]="isFieldChanged('mayMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="mayMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('mayMaterial')) {
                    <span class="old-value">{{ getOldValue('mayMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('may', 'service')"
                    [class.changed-field]="isFieldChanged('mayService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="mayService"
                      maxlength="20000" />
                    @if (isFieldChanged('mayService')) {
                    <span class="old-value">{{ getOldValue('mayService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('may', 'other')"
                    [class.changed-field]="isFieldChanged('mayOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="mayOther"
                      maxlength="20000" />
                    @if (isFieldChanged('mayOther')) {
                    <span class="old-value">{{ getOldValue('mayOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="mayTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('mayTotal')?.value ?? 0) + getCarriedOverRowTotal('may')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('mayTotal')?.value ?? 0) + getCarriedOverRowTotal('may')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.JUN' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jun', 'material')"
                    [class.changed-field]="isFieldChanged('junMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="junMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('junMaterial')) {
                    <span class="old-value">{{ getOldValue('junMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jun', 'service')"
                    [class.changed-field]="isFieldChanged('junService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="junService"
                      maxlength="20000" />
                    @if (isFieldChanged('junService')) {
                    <span class="old-value">{{ getOldValue('junService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jun', 'other')"
                    [class.changed-field]="isFieldChanged('junOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="junOther"
                      maxlength="20000" />
                    @if (isFieldChanged('junOther')) {
                    <span class="old-value">{{ getOldValue('junOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="junTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('junTotal')?.value ?? 0) + getCarriedOverRowTotal('jun')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('junTotal')?.value ?? 0) + getCarriedOverRowTotal('jun')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.JUL' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jul', 'material')"
                    [class.changed-field]="isFieldChanged('julMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="julMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('julMaterial')) {
                    <span class="old-value">{{ getOldValue('julMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jul', 'service')"
                    [class.changed-field]="isFieldChanged('julService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="julService"
                      maxlength="20000" />
                    @if (isFieldChanged('julService')) {
                    <span class="old-value">{{ getOldValue('julService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('jul', 'other')"
                    [class.changed-field]="isFieldChanged('julOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="julOther"
                      maxlength="20000" />
                    @if (isFieldChanged('julOther')) {
                    <span class="old-value">{{ getOldValue('julOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="julTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('julTotal')?.value ?? 0) + getCarriedOverRowTotal('jul')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('julTotal')?.value ?? 0) + getCarriedOverRowTotal('jul')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.AUG' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('aug', 'material')"
                    [class.changed-field]="isFieldChanged('augMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="augMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('augMaterial')) {
                    <span class="old-value">{{ getOldValue('augMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('aug', 'service')"
                    [class.changed-field]="isFieldChanged('augService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="augService"
                      maxlength="20000" />
                    @if (isFieldChanged('augService')) {
                    <span class="old-value">{{ getOldValue('augService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('aug', 'other')"
                    [class.changed-field]="isFieldChanged('augOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="augOther"
                      maxlength="20000" />
                    @if (isFieldChanged('augOther')) {
                    <span class="old-value">{{ getOldValue('augOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="augTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('augTotal')?.value ?? 0) + getCarriedOverRowTotal('aug')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('augTotal')?.value ?? 0) + getCarriedOverRowTotal('aug')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.SEP' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('sep', 'material')"
                    [class.changed-field]="isFieldChanged('sepMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="sepMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('sepMaterial')) {
                    <span class="old-value">{{ getOldValue('sepMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('sep', 'service')"
                    [class.changed-field]="isFieldChanged('sepService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="sepService"
                      maxlength="20000" />
                    @if (isFieldChanged('sepService')) {
                    <span class="old-value">{{ getOldValue('sepService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('sep', 'other')"
                    [class.changed-field]="isFieldChanged('sepOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="sepOther"
                      maxlength="20000" />
                    @if (isFieldChanged('sepOther')) {
                    <span class="old-value">{{ getOldValue('sepOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="sepTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('sepTotal')?.value ?? 0) + getCarriedOverRowTotal('sep')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('sepTotal')?.value ?? 0) + getCarriedOverRowTotal('sep')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.OCT' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('oct', 'material')"
                    [class.changed-field]="isFieldChanged('octMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="octMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('octMaterial')) {
                    <span class="old-value">{{ getOldValue('octMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('oct', 'service')"
                    [class.changed-field]="isFieldChanged('octService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="octService"
                      maxlength="20000" />
                    @if (isFieldChanged('octService')) {
                    <span class="old-value">{{ getOldValue('octService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('oct', 'other')"
                    [class.changed-field]="isFieldChanged('octOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="octOther"
                      maxlength="20000" />
                    @if (isFieldChanged('octOther')) {
                    <span class="old-value">{{ getOldValue('octOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="octTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('octTotal')?.value ?? 0) + getCarriedOverRowTotal('oct')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('octTotal')?.value ?? 0) + getCarriedOverRowTotal('oct')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.NOV' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('nov', 'material')"
                    [class.changed-field]="isFieldChanged('novMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="novMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('novMaterial')) {
                    <span class="old-value">{{ getOldValue('novMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('nov', 'service')"
                    [class.changed-field]="isFieldChanged('novService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="novService"
                      maxlength="20000" />
                    @if (isFieldChanged('novService')) {
                    <span class="old-value">{{ getOldValue('novService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('nov', 'other')"
                    [class.changed-field]="isFieldChanged('novOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="novOther"
                      maxlength="20000" />
                    @if (isFieldChanged('novOther')) {
                    <span class="old-value">{{ getOldValue('novOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="novTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('novTotal')?.value ?? 0) + getCarriedOverRowTotal('nov')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('novTotal')?.value ?? 0) + getCarriedOverRowTotal('nov')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.MONTHS_SHORT.DEC' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('dec', 'material')"
                    [class.changed-field]="isFieldChanged('decMaterial')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="decMaterial"
                      maxlength="20000" />
                    @if (isFieldChanged('decMaterial')) {
                    <span class="old-value">{{ getOldValue('decMaterial') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('dec', 'service')"
                    [class.changed-field]="isFieldChanged('decService')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="decService"
                      maxlength="20000" />
                    @if (isFieldChanged('decService')) {
                    <span class="old-value">{{ getOldValue('decService') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width"
                    [class.highlighted-cell]="shouldHighlightCell('dec', 'other')"
                    [class.changed-field]="isFieldChanged('decOther')">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="decOther"
                      maxlength="20000" />
                    @if (isFieldChanged('decOther')) {
                    <span class="old-value">{{ getOldValue('decOther') }}</span>
                    }
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="decTotal"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('decTotal')?.value ?? 0) + getCarriedOverRowTotal('dec')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('decTotal')?.value ?? 0) + getCarriedOverRowTotal('dec')) | number:'1.2-2'}} }
                  </div>
                </td>
                }
              </tr>

              <tr>
                <td>{{ 'COMMON.COST_TYPES.TOTAL' | translate }}</td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input class="totals-" matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true"
                      [kAmountEnabled]="showInK" suffix=" k$" type="number" (input)="calculateTotals()"
                      formControlName="totalMaterial" maxlength="20000" />
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="totalService"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="totalOther"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="fill" class="full-width">
                    <input matInput kCurrency [fractionDigits]="2" [hideSuffixOnFocus]="true" [kAmountEnabled]="showInK"
                      suffix=" k$" type="number" (input)="calculateTotals()" formControlName="total"
                      maxlength="20000" />
                  </mat-form-field>
                </td>
                @if(carriedOverCostTotals) {
                <td class="grand-total-cell grand-total-totals-row" [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL_TOOLTIP' | translate">
                  <div class="grand-total-value">
                    @if(showInK) { {{((projectTotalsForm.get('total')?.value ?? 0) + getCarriedOverColTotal('Material') + getCarriedOverColTotal('Service') + getCarriedOverColTotal('Other')) | compactCurrency}} }
                    @else { {{((projectTotalsForm.get('total')?.value ?? 0) + getCarriedOverColTotal('Material') + getCarriedOverColTotal('Service') + getCarriedOverColTotal('Other')) | number:'1.2-2'}} }
                  </div>
                </td>
                }

              </tr>
            </table>
          </div>
        </div>
        <!-- @if(!isForecastOpened&& isForForecasts){
      <p class="totals-warning">Forecasting is closed.</p>
    } -->
      </form>

      @if(carriedOverCostTotals) {
      <div class="section-divider" (click)="toggleCarriedOver()">
        <mat-icon>{{ isCarriedOverSectionExpanded ? 'chevron_left' : 'chevron_right' }}</mat-icon>
      </div>
      @if(isCarriedOverSectionExpanded) {
      <div class="carried-over-section">
        <div class="table-wrapper-dialog">
          <div class="table-header-fixed">
            <table cellpadding="0" cellspacing="4" border="0">
              <tr>
                <th colspan="5" class="section-title-row">{{ 'DIALOGS.PROJECT_TOTALS.CARRIED_OVER_TITLE' | translate }}
                  <span class="section-title-divider">|</span>
                  <span [matTooltip]="'DIALOGS.PROJECT_TOTALS.AFE_NUMBER' | translate">{{ data.carriedOver?.afeNumber??0
                    }}</span>
                  <!-- <span class="section-title-divider">|</span>
                <span [matTooltip]="'DIALOGS.PROJECT_TOTALS.AFE_AMOUNT' | translate">{{ (data.carriedOver?.afeAmount ?? 0) | number:'1.2-2' }}</span>
                <span class="section-title-divider">|</span>
                <span [matTooltip]="'DIALOGS.PROJECT_TOTALS.APPROVED_BUDGET' | translate">{{ (data.carriedOver?.approvedBudget ?? 0) | number:'1.2-2' }}</span> -->
                </th>
              </tr>
              <tr>
                <th>{{ 'COMMON.LABELS.MONTH' | translate }}&nbsp;</th>
                <th>{{ 'COMMON.COST_TYPES.MATERIAL' | translate }}{{showInK ? ', K$' : ''}}</th>
                <th>{{ 'COMMON.COST_TYPES.SERVICE' | translate }}{{showInK ? ', K$' : ''}}</th>
                <th>{{ 'COMMON.COST_TYPES.OTHER' | translate }}{{showInK ? ', K$' : ''}}</th>
                <th>{{ 'COMMON.COST_TYPES.TOTAL' | translate }}{{showInK ? ', K$' : ''}}</th>
              </tr>
            </table>
          </div>
          <div class="table-body-scroll">
            <table cellpadding="0" cellspacing="4" border="0">
              @for(m of carriedOverMonths; track m.key) {
              <tr>
                <td>{{ m.label | translate }}</td>
                <td class="readonly-value">
                  @if(showInK) { {{getCarriedOverValue(m.key, 'Material') | compactCurrency}}}
                  @else { {{getCarriedOverValue(m.key, 'Material') | number:'1.2-2'}} }
                </td>
                <td class="readonly-value">
                  @if(showInK) { {{getCarriedOverValue(m.key, 'Service') | compactCurrency}} }
                  @else { {{getCarriedOverValue(m.key, 'Service') | number:'1.2-2'}} }
                </td>
                <td class="readonly-value">
                  @if(showInK) { {{getCarriedOverValue(m.key, 'Other') | compactCurrency}}}
                  @else { {{getCarriedOverValue(m.key, 'Other') | number:'1.2-2'}} }
                </td>
                <td class="readonly-value">
                  @if(showInK) { {{getCarriedOverRowTotal(m.key) | compactCurrency}} }
                  @else { {{getCarriedOverRowTotal(m.key) | number:'1.2-2'}} }
                </td>
              </tr>
              }
              <tr class="carried-over-totals-row">
                <td><strong>{{ 'COMMON.COST_TYPES.TOTAL' | translate }}</strong></td>
                <td class="readonly-value"><strong>
                    @if(showInK) { {{getCarriedOverColTotal('Material') | compactCurrency}} }
                    @else { {{getCarriedOverColTotal('Material') | number:'1.2-2'}} }
                  </strong></td>
                <td class="readonly-value"><strong>
                    @if(showInK) { {{getCarriedOverColTotal('Service') | compactCurrency}} }
                    @else { {{getCarriedOverColTotal('Service') | number:'1.2-2'}} }
                  </strong></td>
                <td class="readonly-value"><strong>
                    @if(showInK) { {{getCarriedOverColTotal('Other') | compactCurrency}} }
                    @else { {{getCarriedOverColTotal('Other') | number:'1.2-2'}} }
                  </strong></td>
                <td class="readonly-value"><strong>
                    @if(showInK) { {{(getCarriedOverColTotal('Material') + getCarriedOverColTotal('Service') +
                    getCarriedOverColTotal('Other')) | compactCurrency}} }
                    @else { {{(getCarriedOverColTotal('Material') + getCarriedOverColTotal('Service') +
                    getCarriedOverColTotal('Other')) | number:'1.2-2'}} }
                  </strong></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      }
      }
    </div>
  </mat-dialog-content>

  @if(hasPendingBreakInOut){
  <button type="button" class="pending-break-in-out-header" (click)="openPendingBreakInOut()">{{ 'BREAK_IN_OUT.PENDING_WARNING' | translate }}</button>
  }

  <mat-dialog-actions>
    @if(isForForecasts && isFullAccess){
    <!-- <button mat-raised-button [disabled]="isEditingActuals || hasPendingBreakInOut || noChanges() || !canAddBreakInOut" -->
    <button mat-raised-button [disabled]="isEditingActuals || hasPendingBreakInOut || !canAddBreakInOut"
      class="breakinout left-aligned-button"
      [class.disable]="isEditingActuals || hasPendingBreakInOut || !canAddBreakInOut" (click)="onBreakInOut()">{{
      'BREAK_IN_OUT.NEW_BREAK_IN_OUT' | translate }}</button>
    }
    <!-- @if (isPowerUserStaged())
    { <button mat-raised-button [disabled]="!isPowerUserStaged()" (click)="editActuals()">Edit Actuals</button>} -->
    <div class="grand-totals-group">
      @if(carriedOverCostTotals){
      <div class="totals-summary-card">
        @if(!isCarriedOverSectionExpanded){
        <div class="totals-summary-row">
          <span class="totals-summary-label">Carried Over Total</span>
          <span class="totals-summary-value">
            @if(showInK) {
            {{(getCarriedOverColTotal('Material') + getCarriedOverColTotal('Service') + getCarriedOverColTotal('Other'))
            | compactCurrency }} k$
            } @else {
            {{ (getCarriedOverColTotal('Material') + getCarriedOverColTotal('Service') +
            getCarriedOverColTotal('Other')) | number:'1.2-2' }}
            }
          </span>
        </div>
        }
        <div class="totals-summary-row totals-summary-grand"
          [matTooltip]="'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL' | translate">
          <span class="totals-summary-label">{{ 'DIALOGS.PROJECT_TOTALS.GRAND_TOTAL' | translate }}</span>
          <span class="totals-summary-value">
            @if(showInK) {
            {{ ((projectTotalsForm.get('total')?.value ?? 0) + getCarriedOverColTotal('Material') +
            getCarriedOverColTotal('Service') + getCarriedOverColTotal('Other')) | compactCurrency }} k$
            } @else {
            {{ ((projectTotalsForm.get('total')?.value ?? 0) + getCarriedOverColTotal('Material') +
            getCarriedOverColTotal('Service') + getCarriedOverColTotal('Other')) | number:'1.2-2' }}
            }
          </span>
        </div>
      </div>
      }
      <div class="action-buttons">
        <button mat-raised-button [disabled]="!isSaveAllowed()" class="submit" (click)="onSave()">{{
          'COMMON.BUTTONS.SAVE' | translate }}</button>
        <button mat-button class="discard-changes" (click)="onCancel()">
          {{ 'COMMON.BUTTONS.CANCEL' | translate }}
        </button>
      </div>
    </div>

  </mat-dialog-actions>
</div>